var React = require('react');

function AffordableTariffs (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M41.6 6H6.4C3.958 6 2.022 7.94687 2.022 10.375L2 36.625C2 39.0531 3.958 41 6.4 41H41.6C44.042 41 46 39.0531 46 36.625V10.375C46 7.94687 44.042 6 41.6 6ZM41.6 36.625H6.4V23.5H41.6V36.625ZM41.6 14.75H6.4V10.375H41.6V14.75Z","fill":"black"}));
}

AffordableTariffs.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = AffordableTariffs;

AffordableTariffs.default = AffordableTariffs;
